var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.strongContractAuthentication && !_vm.offerRequest
        ? _c("authentication", {
            attrs: {
              "test-mode": _vm.contract.TestMode,
              "show-authentication": _vm.strongContractAuthentication,
              "hide-authentication-forced-text":
                _vm.hideAuthenticationForcedText
            },
            on: { authenticate: _vm.authenticate }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.offerRequest ||
      (_vm.customer.TrustedSource && _vm.strongContractAuthentication)
        ? _c(
            "div",
            [
              [
                !_vm.offerRequest
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "6", lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [_vm._v(_vm._s(_vm.$t("Nimi")))]
                                ),
                                _c(
                                  "p",
                                  { staticClass: "form-control-static" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.customer.FirstName) +
                                        " " +
                                        _vm._s(_vm.customer.LastName)
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "6", lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "font-weight-bold pt-0" },
                                  [_vm._v(_vm._s(_vm.$t("Henkilötunnus")))]
                                ),
                                _c(
                                  "validated-form-group",
                                  {
                                    attrs: {
                                      "validation-id": "Pin",
                                      "validation-errors": _vm.validationErrors
                                    }
                                  },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "form-control-static" },
                                      [_vm._v(_vm._s(_vm.customer.Pin))]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.strongContractAuthentication || _vm.offerRequest
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "6", lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold pt-0",
                                    attrs: {
                                      for:
                                        "customer_information_firstname_field"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Etunimi")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "FirstName",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "customer_information_firstname_field",
                                    name: "FirstName",
                                    value: _vm.customer.FirstName
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "6", lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold pt-0",
                                    attrs: {
                                      for: "customer_information_lastname_field"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Sukunimi")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "LastName",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "customer_information_lastname_field",
                                    name: "LastName",
                                    value: _vm.customer.LastName
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.offerRequest || _vm.strongContractAuthentication
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "6", lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold pt-0",
                                    attrs: {
                                      for: "customer_information_phone_field"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Puhelinnumero")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "Phone",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    id: "customer_information_phone_field",
                                    name: "Phone",
                                    value: _vm.customer.Phone
                                      ? _vm.customer.Phone
                                      : "+358"
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "6", md: "6", lg: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: {
                                  "label-cols-sm": "12",
                                  "label-cols-md": "12",
                                  "label-cols-lg": "12"
                                }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold pt-0",
                                    attrs: {
                                      for: "customer_information_email_field"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "validated-form-group",
                              {
                                attrs: {
                                  "validation-id": "Email",
                                  "validation-errors": _vm.validationErrors
                                }
                              },
                              [
                                _c("b-form-input", {
                                  directives: [
                                    {
                                      name: "new-contract-value",
                                      rawName: "v-new-contract-value"
                                    }
                                  ],
                                  attrs: {
                                    type: "email",
                                    id: "customer_information_email_field",
                                    name: "Email",
                                    value: _vm.customer.Email
                                  },
                                  on: { "value-updated": _vm.valueUpdated }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.offerRequest || _vm.strongContractAuthentication
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "12", md: "12", lg: "12" } },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$t(
                                    "Mikäli haluat sopimuksen useamman henkilön nimellä, pyydämme sinua ottamaan yhteyttä asiakaspalveluumme."
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }